export default "__VITE_ASSET__DcG$s$D$__"